import { render, staticRenderFns } from "./SortableList.vue?vue&type=template&id=7dffbd2f&scoped=true&"
import script from "./SortableList.vue?vue&type=script&lang=js&"
export * from "./SortableList.vue?vue&type=script&lang=js&"
import style0 from "./SortableList.vue?vue&type=style&index=0&id=7dffbd2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dffbd2f",
  null
  
)

export default component.exports